import { toValue } from 'vue';

function getFirstFocusableElement(elementOrRef) {
  const el = toValue(elementOrRef);
  const focusableElements = el?.querySelectorAll(
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex^="-"]), [contenteditable]',
  );
  return focusableElements?.[0]
}

let returnFocusElement = null;
const vFocus = {
  mounted(el) {
    returnFocusElement = document.activeElement;
    const firstFocusableElement = getFirstFocusableElement(el);
    if (firstFocusableElement)
      firstFocusableElement.focus();
  },
  beforeUnmount() {
    returnFocusElement.focus();
    returnFocusElement = null;
  }
};

export { vFocus as v };
//# sourceMappingURL=focus-Dhhiawn_.js.map
